import { useEffect, useMemo, useRef, useState } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
export const DEFAULT_FEEDBACK_DISPLAY_DURATION_MS = 3000;
export const useCopyTooltipState = ({ duration = DEFAULT_FEEDBACK_DISPLAY_DURATION_MS, onCopyClick, }) => {
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [hintVisible, setHintVisible] = useState(false);
    const timeoutRef = useRef(null);
    const handleCopyClick = useCallbackRef((event) => {
        event.stopPropagation();
        event.preventDefault();
        setHintVisible(false);
        setFeedbackVisible(true);
        timeoutRef.current = setTimeout(() => {
            setFeedbackVisible(false);
        }, duration);
        onCopyClick?.(event);
    });
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return useMemo(() => ({
        feedbackVisible: feedbackVisible,
        hintVisible: hintVisible && !feedbackVisible,
        onCopyClick: handleCopyClick,
        onHintVisibleChange: setHintVisible,
    }), [handleCopyClick, feedbackVisible, hintVisible]);
};
